import React, { useState } from 'react';
import './weekBooking.css';
import { useDispatch, useSelector } from "react-redux";
import { copyDayBookingSagaAction, getBookingUsersSagaAction } from "../../redux/sagaActions";
import { bookingFormAction, calendarAction } from "../../redux/rootReducer";
import CalendarForm from "../CalendarForm/CalendarForm";
import { CALENDAR_INITIAL } from "../../redux/initialStateConstant";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const WeekBooking = () => {
    const dispatch = useDispatch();
    const weekBooking = useSelector(state => state.weekBooking);
    const bookingForm = useSelector(state => state.bookingForm);
    const calendar = useSelector(state => state.calendar);

    const [copyDay, setCopyDay] = useState(null);

    return (
        <div className="page">
            <div className="week">
                {
                    calendar.type === 'booking_copy_day' &&
                    <CalendarForm
                        title={ `Копирование ${ copyDay.date_formatted }` }
                        close={ () => {
                            setCopyDay(null);
                            dispatch(calendarAction(CALENDAR_INITIAL));
                        } }
                        submit={ daysArr => dispatch(copyDayBookingSagaAction({
                            date: copyDay.date,
                            copy_days: JSON.stringify(daysArr)
                        })) }
                    />
                }
                <div className="week__days">
                    {
                        weekBooking?.week_booking.map(day => {
                            return (
                                <div className={ `week__day ${ day.date === weekBooking.today ? 'week__day--today' : '' }` } key={ day.date }>
                                    <div className="week__header">
                                        <Tippy content="Копирование занятий на текущий день" touch={ false }>
                                            <i className="week__copy"
                                               onClick={ () => {
                                                   setCopyDay({
                                                       date_formatted: day.date_formatted,
                                                       date: day.date
                                                   });
                                                   dispatch(calendarAction({
                                                       ...calendar,
                                                       open: true,
                                                       type: 'booking_copy_day'
                                                   }));
                                               } }
                                            />
                                        </Tippy>
                                        {
                                            new Date(day.date).getTime() >= new Date(weekBooking.today).getTime()
                                                ?
                                                <Tippy content="Создание нового занятия" touch={ false }>
                                                    <i className="week__add"
                                                       onClick={ () => {
                                                           dispatch(bookingFormAction({
                                                               ...bookingForm,
                                                               open: true,
                                                               date: day.date
                                                           }));
                                                       } }
                                                    />
                                                </Tippy>
                                            :   false
                                        }
                                        <div className="week__day-name">{ day.day }</div>
                                        <div className="week__date">{ day.date_formatted }</div>
                                    </div>
                                    <div className="week__items">
                                        {
                                            day.booking.map(item => {
                                                return (
                                                    <div className="week__item"
                                                         style={{ backgroundColor: item.color }}
                                                         key={ item.id }
                                                         onClick={ () => {
                                                             // Получение списка пользователей для указанной записи
                                                             dispatch(getBookingUsersSagaAction({
                                                                 booking_id: item.id,
                                                                 canceled: item.canceled
                                                             }));
                                                         } }
                                                    >
                                                        { item.canceled && <div className="week__canceled">{ item.canceled }</div> }
                                                        <div className="week__settings"
                                                            onClick={ event => {
                                                                event.preventDefault();
                                                                event.stopPropagation();
                                                                // Открываем форму настроек группового занятия
                                                                dispatch(bookingFormAction({
                                                                    ...bookingForm,
                                                                    open: true,
                                                                    id: item.id,
                                                                    date: item.date,
                                                                    time: item.time,
                                                                    type: item.type,
                                                                    coach: item.coach,
                                                                    max_users: item.max_users,
                                                                    hide_users: item.hide_users,
                                                                    name: item.name,
                                                                    bound_subscriptions: item.bound_subscriptions,
                                                                    color: item.color,
                                                                    remind_datetime: item.remind_datetime,
                                                                    start_registration_date: item.start_registration_date,
                                                                    start_registration_time: item.start_registration_time,
                                                                    finish_registration_hours: item.finish_registration_hours,
                                                                    canceled: item.canceled,
                                                                    hide_in_app: item.hide_in_app
                                                                }));
                                                            } }
                                                        />
                                                        <div className="week__meta">
                                                            <div className="week__time">{ item.time }</div>
                                                            <div className="week__type">{ item.type.name }</div>
                                                            <div className="week__icons">
                                                                {
                                                                    item.bound_subscriptions.length
                                                                        ?
                                                                        <Tippy
                                                                            content="Доступные для записи типы абонементов"
                                                                            touch={ false }
                                                                        >
                                                                            <div className="week__icon week__icon--bound-subscriptions"/>
                                                                        </Tippy>
                                                                        : false
                                                                }
                                                                {
                                                                    item.remind_datetime
                                                                        ?
                                                                        <Tippy content="Напоминание" touch={ false }>
                                                                            <div className="week__icon week__icon--remind"/>
                                                                        </Tippy>
                                                                        : false
                                                                }
                                                                {
                                                                    item.hide_users === 1
                                                                        ?
                                                                        <Tippy content="Скрыть посетителей" touch={ false }>
                                                                            <div className="week__icon week__icon--hide-users"/>
                                                                        </Tippy>
                                                                        : false
                                                                }
                                                                {
                                                                    item.start_registration_date.id !== '0' || item.finish_registration_hours !== '0'
                                                                    ?
                                                                        <Tippy content="Ограничение времени записи" touch={ false }>
                                                                            <div className="week__icon week__icon--start_registration"/>
                                                                        </Tippy>
                                                                    : false
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="week__name">{ item.name }</div>
                                                        {
                                                            item.coach?.name &&
                                                            <div className="week__coach">{ item.coach.name }</div>
                                                        }
                                                        <div className="week__booking">
                                                            <div className="week__booking-count">{ `Записано ${ item.booking_count } из ${ item.max_users }` }</div>
                                                            <div className="week__booking-line" style={{ width: +(parseInt(item.booking_count) / parseInt(item.max_users)).toFixed(2) * 100 + '%' }}/>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default WeekBooking;